import { useTheme } from "@mui/material";
import DSBox from "../system-design/DSBox";
import DSTypography from "../system-design/Typography/DSTypography";
import DSPaper from "../system-design/DSPaper";
import { isIOS, isMobile } from "react-device-detect";
import DSSwitch from "../system-design/DSSwitch";
import GiftView from "./GiftView";
import useGiftQuery from "./hooks/useGiftQuery";
import { useHistory } from "../../utils";
import { SplashScreen } from "../../LoginView/SplashScreen";
import { useState } from "react";
import { KLYDO_YELLOW } from "../../consts/colors";
import GreetLogo from "../system-design/GreetLogo";
import { PopulatedGift } from "../../api/gift";

const GiftShare = () => {
  const theme = useTheme();
  const { search } = useHistory();

  const { data: giftInfo, isLoading: isLoadingGift } = useGiftQuery({
    orderName: (search.orderName || search.orderId) as string,
    clockId: search.clockId as string,
  });
  const gift: PopulatedGift = giftInfo?.gift;

  const selectedKlydoGreet = gift?.klydo;
  const klydoGiftProps = {
    senderImageUrl: gift?.senderImageUrl,
    senderName: gift?.senderName,
    date: gift?.date,
    greetingContent: gift?.greetingContent,
    pendulumLogoUrl: gift?.pendulumLogoUrl,
    orderName: gift?.orderName || "",
    clockId: giftInfo?.clockInfo?.id || "",
    klydoId: gift?.klydoId,
    timeZone: gift?.timeZone,
    giftId: gift?.giftId,
  };

  const [showGreeting, setShowGreeting] = useState(false);
  const handleToggle = (event) => {
    setShowGreeting(event.target.checked);
  };

  if (isLoadingGift) return SplashScreen();

  return (
    <DSPaper
      style={{
        height: "100vh",
        overflow: "scroll",
      }}
    >
      <DSBox
        color="transparent"
        sx={{
          backgroundColor: theme.palette.background.paper,
          paddingY: 4,
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          alignItems: "center",
          boxShadow: "none",
        }}
      >
        <GreetLogo color={KLYDO_YELLOW} />
      </DSBox>
      <DSBox
        sx={{
          flexDirection: "column",
          justifyContent: "center",
          textAlign: "center",
          alignItems: "center",
          backgroundColor: theme.palette.background.paper,
          height: "100vh",
        }}
      >
        <DSBox
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: isIOS && isMobile ? "250px" : "290px",
              height: isIOS && isMobile ? "420px" : "483px",
              position: "relative",
            }}
          >
            <GiftView
              gift={klydoGiftProps}
              klydo={selectedKlydoGreet}
              isToggled={showGreeting}
            />
          </div>
          <DSBox
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              width: "100%",
            }}
          >
            <DSTypography
              fontFamily={"Gilroy-SemiBold"}
              fontSize={"16px"}
              color={showGreeting ? "#A5A5A5" : "#FFFFFF"}
            >
              Greet
            </DSTypography>

            <DSSwitch checked={showGreeting} onChange={handleToggle} />

            <DSTypography
              fontFamily={"Gilroy-SemiBold"}
              fontSize={"16px"}
              color={showGreeting ? "#FFFFFF" : "#A5A5A5"}
            >
              Message
            </DSTypography>
          </DSBox>
        </DSBox>
      </DSBox>
    </DSPaper>
  );
};
export default GiftShare;
